import { newStepValue } from '../../../../services/flowBuilder/utils/constants';
import { DynamicLayout } from '../../formbuilder';

const richLinkVideo: DynamicLayout = {
  json: {
    menu: {
      menuType: 'richLink',
      menuHeader: '',
      url: '',
      menuParams: {
        preview: {
          image: '',
          previewType: '',
          videoUrl: '',
          videoMimeType: '',
        },
      },
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: [
    'menu.menuParams.preview.image',
    'menu.menuHeader',
    'menu.url',
    'menu.menuParams.preview.previewType',
    'menu.menuParams.preview.videoUrl',
    'menu.menuParams.preview.videoMimeType',
    'next',
  ],
  groups: [
    {
      Parameters: [
        'menu.menuParams.preview.image',
        'menu.menuHeader',
        'menu.url',
        'menu.menuParams.preview.previewType',
        'menu.menuParams.preview.videoUrl',
        'menu.menuParams.preview.videoMimeType',
      ],
    },
    {
      Logic: ['next'],
    },
  ],
};

const richLinkImage: DynamicLayout = {
  json: {
    menu: {
      menuType: 'richLink',
      menuHeader: '',
      url: '',
      menuParams: {
        preview: {
          image: '',
          previewType: '',
        },
      },
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: [
    'menu.menuParams.preview.image',
    'menu.menuHeader',
    'menu.url',
    'menu.menuParams.preview.previewType',
    'next',
  ],
  groups: [
    {
      Parameters: [
        'menu.menuParams.preview.image',
        'menu.menuHeader',
        'menu.url',
        'menu.menuParams.preview.previewType',
      ],
    },
    {
      Logic: ['next'],
    },
  ],
};

export const richLink: DynamicLayout = {
  json: {
    menu: {
      menuType: 'richLink',
      menuHeader: '',
      url: '',
      menuParams: {
        preview: {
          image: '',
          previewType: 'IMAGE',
        },
      },
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: [
    'menu.menuParams.preview.image',
    'menu.menuHeader',
    'menu.url',
    'menu.menuParams.preview.previewType',
    'next',
  ],
  groups: [
    {
      Parameters: [
        'menu.menuParams.preview.image',
        'menu.menuHeader',
        'menu.url',
        'menu.menuParams.preview.previewType',
      ],
    },
    {
      Logic: ['next'],
    },
  ],
  layout: {
    menuHeader: {
      type: 'text',
      label: 'Title',
      validators: {
        required: true,
      },
    },
    url: {
      type: 'text',
      label: 'URL',
      validators: {
        required: true,
      },
    },
    image: {
      type: 'image',
      label: '',
      validators: {
        required: false,
      },
    },
    videoUrl: {
      type: 'text',
      label: 'Video Url',
      validators: {
        required: true,
      },
    },
    videoMimeType: {
      type: 'text',
      label: 'Mime Type',
      validators: {
        required: true,
      },
    },
    next: {
      type: 'next',
      label: 'Point to',
      validators: {
        optionSelected: true,
      },
    },
    previewType: {
      type: 'selector',
      label: '*',
      attributes: {
        options: {
          IMAGE: 'URL',
          VIDEO: 'Video',
        },
        data: true,
      },
    },
  },
  data: {
    dataPath: 'menu.menuParams.preview.previewType',
    previewType: {
      IMAGE: richLinkImage,
      VIDEO: richLinkVideo,
    },
  },
};
